export const MACBOOK_PROMO_STEPS = [
  {
    eyebrow: "Digital Experience — 02",
    title: ["스크롤 한 번으로", "열리는 브랜드 경험"],
    body: "첫 화면부터 설득력 있는 디지털 접점을 설계합니다.",
  },
  {
    eyebrow: "Brand First",
    title: ["브랜드의 첫 인상은", "웹에서 시작됩니다"],
    body: "방문자가 기억하는 순간까지, 메시지와 구조를 함께 만듭니다.",
  },
  {
    eyebrow: "One Flow",
    title: ["전략 · 디자인 · 개발", "하나의 흐름으로"],
    titleLineClass: ["ds-macbook-scroll-open__promo-title-line--compact", ""],
    bodyLines: ["기획부터 구현까지 끊김 없이 이어지는", "프로세스를 제공합니다."],
  },
  {
    eyebrow: "Scale Ready",
    title: ["확장 가능한", "디지털 인프라"],
    body: "웹 · SaaS · 관리자 · AI 자동화까지 기업 성장에 맞춰 설계합니다.",
  },
  {
    eyebrow: "DSITESOLUTION",
    title: ["NO. 1 BRAND", "DIGITAL", "SOLUTION"],
    titleLineClass: [
      "ds-macbook-scroll-open__promo-title-line--en",
      "ds-macbook-scroll-open__promo-title-line--en",
      "ds-macbook-scroll-open__promo-title-line--en",
    ],
    bodyLines: ["지금, 우리가 만든", "작업물을 확인하세요."],
  },
];

export function parseTagline(value, fallback = []) {
  if (Array.isArray(value) && value.length) {
    return value.map((item) => String(item).trim()).filter(Boolean);
  }
  const text = String(value || "").trim();
  if (!text) return fallback;
  return text.split(",").map((item) => item.trim()).filter(Boolean);
}

export function parseTitleLines(value, fallback = []) {
  if (Array.isArray(value) && value.length) {
    return value.map((item) => String(item)).filter((item) => item !== "");
  }
  const text = String(value || "");
  if (!text.trim()) return fallback;
  return text.split("\n");
}

export function parseJsonList(value, fallback = []) {
  if (Array.isArray(value)) return value;
  if (typeof value === "string" && value.trim().startsWith("[")) {
    try {
      const parsed = JSON.parse(value);
      return Array.isArray(parsed) ? parsed : fallback;
    } catch {
      return fallback;
    }
  }
  return fallback;
}

export const MAIN_HERO_FALLBACK = {
  en: {
    line1: "Beyond Websites.",
    line2Before: "We Build ",
    line2Highlight: "Growth Systems.",
    tagline: ["WEB", "AI", "AUTOMATION", "SAAS"],
    ctaLead: "Explore our work in one place",
    ctaLabel: "View Portfolio",
  },
  kr: {
    line1: "웹사이트 그 이상.",
    line2Before: "",
    line2Highlight: "성장 시스템",
    line2After: "을 만듭니다.",
    tagline: ["웹", "AI", "자동화", "SaaS"],
    ctaLead: "제작 사례를 한곳에서 확인하세요",
    ctaLabel: "포트폴리오 바로가기",
  },
  ctaUrl: "/portfolio/brand-web",
};

export function resolveMainHero(cms = {}) {
  const f = MAIN_HERO_FALLBACK;
  return {
    en: {
      line1: cms.main_hero_en_line1 || f.en.line1,
      line2Before: cms.main_hero_en_line2_before ?? f.en.line2Before,
      line2Highlight: cms.main_hero_en_line2_highlight || f.en.line2Highlight,
      tagline: parseTagline(cms.main_hero_en_tagline, f.en.tagline),
      ctaLead: cms.main_hero_en_cta_lead || f.en.ctaLead,
      ctaLabel: cms.main_hero_en_cta_label || f.en.ctaLabel,
    },
    kr: {
      line1: cms.main_hero_kr_line1 || f.kr.line1,
      line2Before: "",
      line2Highlight: cms.main_hero_kr_line2_highlight || f.kr.line2Highlight,
      line2After: cms.main_hero_kr_line2_after ?? f.kr.line2After,
      tagline: parseTagline(cms.main_hero_kr_tagline, f.kr.tagline),
      ctaLead: cms.main_hero_kr_cta_lead || f.kr.ctaLead,
      ctaLabel: cms.main_hero_kr_cta_label || f.kr.ctaLabel,
    },
    ctaUrl: cms.main_hero_cta_url || f.ctaUrl,
  };
}

export const DEFAULT_AUTOMATION_STEPS = [
  { label: "상담", desc: "고객 비즈니스 진단" },
  { label: "분석", desc: "요구사항 · 데이터 흐름 설계" },
  { label: "개발", desc: "맞춤형 웹 · 플랫폼 구축" },
  { label: "자동화", desc: "AI · 알림 · CRM 통합" },
  { label: "운영", desc: "지속 유지보수 · 그로스" },
];

export function resolveAutomation(cms = {}) {
  const steps = parseJsonList(cms.automation_steps, DEFAULT_AUTOMATION_STEPS);
  return {
    eyebrow: cms.automation_eyebrow || "Automation Workflow",
    title: cms.automation_title || "상담에서 운영까지\n한 흐름으로 자동화합니다.",
    description:
      cms.automation_description ||
      "사람이 반복해야 했던 단계를 AI와 자동화가 대신합니다. 비즈니스 흐름에 맞춰 필요한 곳에만 자동화를 설계해 운영 비용을 절감합니다.",
    steps: DEFAULT_AUTOMATION_STEPS.map((fallback, index) => ({
      ...fallback,
      ...(steps[index] || {}),
    })),
  };
}

export function resolveContactCopy(cms = {}) {
  const title = cms.contact_title || "지금 바로\n상담을 시작하세요.";
  const [line1, ...rest] = title.split("\n");
  return {
    eyebrow: cms.contact_eyebrow || "Contact",
    line1: line1 || "지금 바로",
    line2: rest.join("\n") || "상담을 시작하세요.",
    description:
      cms.contact_description ||
      "비즈니스 정보가 정리되어 있지 않아도 괜찮습니다. 첫 미팅에서 함께 진단합니다. 평균 24시간 내 답변드립니다.",
  };
}

export const GEO_DISCLAIMER =
  "이 정보는 검색엔진 및 생성형 AI가 브랜드와 서비스를 더 명확하게 이해할 수 있도록 구조화하는 목적입니다. 특정 AI 답변 노출, 인용, 추천 또는 검색 순위를 보장하지 않습니다.";
